import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    pending: {
        id: 'cards.list.pending',
        defaultMessage: 'Pending',
    },
    frozen: {
        id: 'cards.list.frozen',
        defaultMessage: 'Frozen',
    },
    blocked: {
        id: 'cards.list.blocked',
        defaultMessage: 'Blocked',
    },
    failed: {
        id: 'cards.list.failed',
        defaultMessage: 'Failed',
    },
    active: {
        id: 'cards.list.active',
        defaultMessage: 'Active',
    },
})
